/* eslint-disable import/no-named-default */
import {default as AuthorizationFetcher} from './authorization_fetcher';
/* eslint-enable import/no-named-default */

export {AuthorizationFetcher};
export default {AuthorizationFetcher};
